// src/services/userServiceAdmin.js
import axiosInstance from "./axiosInstance";

// ✅ Lấy tất cả user (dùng cho admin) có phân trang + lọc
export const getAllUsers = async (params = {}) => {
    const res = await axiosInstance.get("/users", { params });
    return res.data;
};

// ✅ Lấy user theo ID + phân trang & lọc danh sách xe
export const getUserById = async (id, params = {}) => {
    // params có thể gồm: page, limit, name, brand, isSold, isNew
    const res = await axiosInstance.get(`/users/${id}`, { params });
    return res.data;
};

// ✅ Tạo user mới
export const createUser = async (userData) => {
    const res = await axiosInstance.post("/users", userData);
    return res.data;
};

// ✅ Cập nhật user
export const updateUser = async (id, userData) => {
    const res = await axiosInstance.put(`/users/${id}`, userData);
    return res.data;
};

// ✅ Xoá user
export const deleteUser = async (id) => {
    const res = await axiosInstance.delete(`/users/${id}`);
    return res.data;
};
